import React, { useEffect, useState } from "react";
import { PiEngineFill } from "react-icons/pi";
import { GrConnect } from "react-icons/gr";
import { GiSpring } from "react-icons/gi";
import { FaDrumSteelpan } from "react-icons/fa6";
import { GiTyre } from "react-icons/gi";
import { FaTachometerAlt } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { GoChecklist } from "react-icons/go";
import { MdOutlineCarCrash } from "react-icons/md";
import { GiCarKey } from "react-icons/gi";
import { BsBank } from "react-icons/bs";
import { FaBook } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import ProgressBar from "react-bootstrap";
import { BsFillLightningFill } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { LiaImageSolid } from "react-icons/lia";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom/dist";
import { moment } from "moment";
import { useSelector } from "react-redux";
import "react-circular-progressbar/dist/styles.css";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import RadialSeparators from "./RadialSeparators";
import { PiEngine } from "react-icons/pi";
import { GiGearStick } from "react-icons/gi";


const TwoWheelerReport = () => {
  const params = useParams();
  const navigate = useNavigate()
  const { organisationLogo } = useSelector((store) => store.orgLogo);
  const { brandLogo } = useSelector((store) => store.brandLogo);
  const [caseinfo, setcaseinfo] = useState("");
  const [casePerfomanceinfo, setcasePerfomanceinfo] = useState("");
  const [caseEngine, setCaseEngine] = useState("");
  const [caseTransmission, setCaseTransmission] = useState("");
  const [caseSuspension, setCaseSuspension] = useState("");
  const [caseBrakes, setCaseBrakes] = useState("");
  const [caseTyre, setCaseTyre] = useState("");
  const [caseInterior, setCaseInterior] = useState("");
  const [caseExterior, setCaseExterior] = useState("");
  const [caseRating, setCaseRating] = useState("");
  const [temploading, setTempLoading] = useState(false);
  const [percentage, setPercentage] = useState(66);

  //   console.log(casePerfomanceinfo,"1");
  console.log(casePerfomanceinfo, "findBrakesCon");

  const roundImageArray = [
    {
      label: "Poor",
      percentage: 2,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png",
    },
    {
      label: "Average",
      percentage: 4,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png",
    },
    {
      label: "Satisfactory",
      percentage: 5,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png",
    },
    {
      label: "Good",
      percentage: 7,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png",
    },
    {
      label: "Excellent",
      percentage: 9,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png",
    },
  ];
  const selectImageArray = [
    {
      label: "Poor",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png",
    },
    {
      label: "Average",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png",
    },
    {
      label: "Satisfactory",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png",
    },
    {
      label: "Good",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png",
    },
    {
      label: "Excellent",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png",
    },
  ];

  useEffect(() => {
    const caseId = params.caseId;
    const fetchData = async () => {
      try {
        const url = `${Baseurl}/api/v1/cases/individualcase/${caseId}`;
        const caseFetch = await axios.get(url);

        try {
          if (caseFetch.data.success) {
            const casedetails = caseFetch.data.case;

            setcaseinfo(casedetails);
            const vehicleType = casedetails.assetType;
            const carCasDetails = casedetails.twoWheeler;

            let findEngineCon = "";
            let findTransmissionCon = "";
            let findSuspensionCon = ''
            let findFrontSuspensionCon = "";
            let findRearSuspensionCon = "";
            let finalSuspensionCon = "";
            let findBrakesCon = "";
            let findTyreCon = "";
            let findElectricalCon = "";
            let findExteriorCon = "";
            let finalBreakCondition = "";
            let finalTyreCondition = "";

            let transmission = carCasDetails.transmission.gearboxCondition;
            if (vehicleType === "Two Wheeler") {
              findEngineCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.engineCondition
              );

              findTransmissionCon = roundImageArray.find(
                (data) => data.label === carCasDetails.transmission.gearboxCondition
              );
              findFrontSuspensionCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.suspension.front
              );

              findRearSuspensionCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.suspension.rear
              );
              findElectricalCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.electricals.electricalCondition
              );
              findExteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.exteriorCondition
              );
              const findRareBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.frontBrakeCondition
              );
              const findFrontBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.rearBrakeCondition
              );
              const TotalSuspension =
                Number(findFrontSuspensionCon.percentage) +
                Number(findRearSuspensionCon.percentage)


              findSuspensionCon = Number(TotalSuspension) / 2;
              findSuspensionCon = Math.round(findSuspensionCon);
              if (findSuspensionCon === 1 || findSuspensionCon === 2) {
                finalSuspensionCon = 2;
              } else if (findSuspensionCon === 3 || findSuspensionCon === 4) {
                finalSuspensionCon = 4;
              } else if (findSuspensionCon === 5 || findSuspensionCon === 6) {
                finalSuspensionCon = 5;
              } else if (findSuspensionCon === 7 || findSuspensionCon === 8) {
                finalSuspensionCon = 7;
              } else if (findSuspensionCon === 9 || findSuspensionCon === 10) {
                finalSuspensionCon = 9;
              }
              const TotalTyreCon =
                Number(carCasDetails.TyresNConditions.lhRear) +
                Number(carCasDetails.TyresNConditions.lhFront)

              findTyreCon = Number(TotalTyreCon) / 20;
              findTyreCon = Math.round(findTyreCon);

              if (findTyreCon === 1 || findTyreCon === 2) {
                finalTyreCondition = 2;
              } else if (findTyreCon === 3 || findTyreCon === 4) {
                finalTyreCondition = 4;
              } else if (findTyreCon === 5 || findTyreCon === 6) {
                finalTyreCondition = 5;
              } else if (findTyreCon === 7 || findTyreCon === 8) {
                finalTyreCondition = 7;
              } else if (findTyreCon === 9 || findTyreCon === 10) {
                finalTyreCondition = 9;
              }
              const totalBrackcon =
                Number(findFrontBrakesCon.percentage) +
                Number(findRareBrakesCon.percentage);
              findBrakesCon = Number(totalBrackcon) / 2;
              findBrakesCon = Math.round(findBrakesCon);


              if (findBrakesCon === 1 || findBrakesCon === 2) {
                finalBreakCondition = 2;
              } else if (findBrakesCon === 3 || findBrakesCon === 4) {
                finalBreakCondition = 4;
              } else if (findBrakesCon === 5 || findBrakesCon === 6) {
                finalBreakCondition = 5;
              } else if (findBrakesCon === 7 || findBrakesCon === 8) {
                finalBreakCondition = 7;
              } else if (findBrakesCon === 9 || findBrakesCon === 10) {
                finalBreakCondition = 9;
              }

              const findBreakCondition = roundImageArray.find(
                (data) => data.percentage === finalBreakCondition
              );
              const findTyreCondition = roundImageArray.find(
                (data) => data.percentage === finalTyreCondition
              );
              const findSuspensionCondition = roundImageArray.find(
                (data) => data.percentage === finalSuspensionCon
              )
              console.log(findSuspensionCondition, "findSuspensionCondition");
              const overalRating =
                Number(findEngineCon.percentage) +
                Number(findTransmissionCon.percentage) +
                Number(findSuspensionCondition.percentage) +
                Number(findElectricalCon.percentage) +
                Number(findExteriorCon.percentage) +
                Number(finalBreakCondition) +
                Number(finalTyreCondition);


              const overalavg = Number(overalRating) / 7;
              setcasePerfomanceinfo({
                findEngineCon: findEngineCon,
                findTransmissionCon: findTransmissionCon,
                findSuspensionCon: findSuspensionCondition,
                findBrakesCon: findBreakCondition,
                findTyreCon: findTyreCondition,
                findElectricalCon: findElectricalCon,
                findExteriorCon: findExteriorCon,
                veralrating: overalavg.toFixed(2),
              });
            } else {
            }
          }
        } catch (error) { }
      } catch (error) { }
    };
    fetchData();
  }, [params.caseId]);

  console.log(caseinfo, "caseinfo");
  console.log(casePerfomanceinfo, "casePerfomanceinfo");


  return (
    <>
      {caseinfo ? (
        <>
          <div>
            <div
              className="content"
              style={{
                border: "1px solid #686868",
                padding: "0 10px",
                width: "100%",
                position: "relative",
              }}
            >
              {/* A4 size */}
              <div className="row noprint p-3">
                <div className="col-sm-6">
                  <a
                    href=""
                    className="btn btn-success"
                    onclick="window.print();"
                  >
                    Print
                  </a>
                </div>
                <div className="col-sm-6 text-right">
                  <a href="" className="btn btn-success">
                    Cancel
                  </a>
                </div>
              </div>
              <div
                className="row"
                style={{
                  padding: "0 10px",
                  fontSize: "12pt",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="col-sm-6">
                  Ref. No / Loan No&nbsp;:&nbsp;{caseinfo.loanAgreementNo}
                </div>
                {caseinfo.caseId > 0 && caseinfo.caseId < 10 ? <> <div className="col-sm-6 text-right">
                  Case ID&nbsp;:&nbsp;0{caseinfo.caseId}
                </div></> : <> <div className="col-sm-6 text-right">
                  Case ID&nbsp;:&nbsp;{caseinfo.caseId}
                </div></>}

              </div>
              <div
                style={{
                  padding: "2px 15px",
                  border: "1px solid #000",
                  width: "100%",
                  height: "auto"
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">
                    <br />
                    <h4>
                      <strong>
                        Valuation Report
                        {/* <br /> */}
                        <p> {caseinfo.assetType}</p>
                        {/* <br /> */}
                        <p><strong>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</strong></p>
                      </strong>
                    </h4>
                    {/* <br /> */}
                    <p> &nbsp;&nbsp;</p>
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>
              <div style={{ padding: "0px 10px", height: "auto" }}>
                <div className="row">
                  <div className="col-sm-7">
                    {/* ==== main col 7*/}
                    <div className="row" style={{ paddingRight: 15 }}>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        City : {caseinfo.city}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Color : {caseinfo.vehicleColor}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Odometer in Kms : {caseinfo.meterReading}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Fuel Type : {caseinfo.fueltype}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Transmission :{" "}
                        {caseinfo.additionalFeatures.transmission}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Accedental status : {caseinfo.otherDetails.accidental}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          Ex. Showroom Price&nbsp;:{caseinfo.marketPrice}
                        </span>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          Estimated Market Value :{caseinfo.valuation}
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* ==== main col 7 end */}
                  <div className="col-sm-5 text-center imfix">
                    <img
                      src={caseinfo.images.frontImage}
                      className="fixed-img"
                    />
                    {/* <br /> */}
                  </div>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row" style={{ padding: "2px 1px", }}>
                <div
                  className="col-sm-12 newReport"
                  style={{ border: "1px solid #000", borderRadius: 2 }}
                >
                  <table width="100%" style={{ padding: "5px 5px" }}>
                    <tbody>
                      <tr className="text-center" style={{ height: "20px" }}>
                        <td width="12%">
                          <div className="center-round">

                            <div className="legcontainer">
                              <img
                                src={casePerfomanceinfo.findEngineCon.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findTransmissionCon
                                    .roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/transm.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findSuspensionCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/tyres.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={casePerfomanceinfo.findBrakesCon.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/electri.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={casePerfomanceinfo.findTyreCon.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/hydra.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/attach.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/hydra.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12%">
                          {casePerfomanceinfo.veralrating > 0.01 &&
                            casePerfomanceinfo.veralrating < 2 ? (
                            <>
                              <div className="center-round">
                                <div className="legcontainer">
                                  <img
                                    //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                    src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png"
                                    alt="Small Image"
                                    className="small-image"
                                  />
                                  <h1
                                    className="image1"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {casePerfomanceinfo.veralrating}
                                  </h1>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {casePerfomanceinfo.veralrating > 2.01 &&
                                casePerfomanceinfo.veralrating < 4 ? (
                                <>
                                  <div className="center-round">
                                    <div className="legcontainer">
                                      <img
                                        //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png"
                                        alt="Small Image"
                                        className="small-image"
                                      />
                                      <h1
                                        className="image1"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {casePerfomanceinfo.veralrating}
                                      </h1>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {casePerfomanceinfo.veralrating > 4.01 &&
                                    casePerfomanceinfo.veralrating < 6 ? (
                                    <>
                                      <div className="center-round">
                                        <div className="legcontainer">
                                          <img
                                            //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                            src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                            alt="Small Image"
                                            className="small-image"
                                          />
                                          <div>
                                            <h1
                                              className="image1"
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              {casePerfomanceinfo.veralrating}
                                            </h1>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {casePerfomanceinfo.veralrating > 6.01 &&
                                        casePerfomanceinfo.veralrating < 8 ? (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg07.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {casePerfomanceinfo.veralrating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {casePerfomanceinfo.veralrating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr className="legtext" style={{ height: "20px" }}>
                        <td>
                          Engine
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findEngineCon.percentage}/10</p>
                        </td>
                        <td>
                          Transmission
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findTransmissionCon.percentage}/10</p>
                        </td>
                        <td>
                          Suspension
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findSuspensionCon.percentage}/10</p>
                        </td>
                        <td>
                          Brakes
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findBrakesCon.percentage}/10</p>
                        </td>
                        <td>
                          Tyres
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findTyreCon.percentage}/10</p>
                        </td>
                        <td>
                          Electricals
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findElectricalCon.percentage}/10</p>
                        </td>
                        <td>
                          Exterior
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findElectricalCon.percentage}/10</p>
                        </td>
                        <td>
                          <strong>
                            OVERALL
                            {/* <br /> */}
                            <p> {casePerfomanceinfo.veralrating} of 10</p>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <table
                    width="100%"
                    border={1}
                    style={{ fontSize: "10pt", border: "1px solid #688", height: "auto" }}
                  >
                    <tbody>
                      <tr className="p-3" style={{ height: "30px" }}>
                        <td width="75%" rowSpan={2}>
                          &nbsp;&nbsp;&nbsp;&nbsp;Inspection Address
                          {/* <br /> */}
                          <p>&nbsp;&nbsp;&nbsp;&nbsp;{caseinfo.vehicleLocation}</p>
                        </td>
                        <td className="text-center">
                          Created Date
                          {/* <br /> */}
                          <p> {caseinfo.createdAt.slice(0, 10)}</p>
                        </td>
                      </tr>
                      <tr style={{ height: "30px" }}>
                        <td className="text-center">
                          Service Date
                          {/* <br /> */}
                          <p> {caseinfo.submittedAt.slice(0, 10)}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div style={{ padding: 8 }} /> */}
              <table>
                <tbody>
                  <tr style={{ height: "20px" }}>
                    <td>
                      <div className="imgcontainer">
                        <img
                          src="/assets/Adsum Advisory Services Pvt. Ltd._files/car01.jpg"
                          className="image3"
                        />
                      </div>
                    </td>
                    <td>
                      <strong>&nbsp;&nbsp;VEHICLE DETAILS</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="row">
                <div className="col-sm-12 newReport">
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ verticalAlign: "top", height: "30px" }}>
                        <td width="24%">
                          <div className="col-sm-12 newReport column-ht" style={{ paddingTop: '0px', height: '100%' }}>
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car08.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: '12px' }}>
                              Registration
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.regdNo}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Chasis Number
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>
                              {caseinfo.chasisNo}
                              {/* <br /> */}
                            </strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Engine Number
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>
                              {caseinfo.engNo}

                            </strong></p>
                            <hr />
                          </div>
                        </td>
                        <td width="24%">
                          <div className="col-sm-12 newReport column-ht" style={{ paddingTop: '0px', height: '100%' }}>
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car02.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: '12px' }}>
                              Body Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.bodyType}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Manufacture Year
                            </p>

                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.manufacturingDate}</strong></p>
                            <p style={{ fontSize: '12px' }}>
                              Date of Registration
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.regdDate}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Vehicle Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.assetType}</strong></p>
                          </div>
                        </td>
                        <td width="25%">
                          <div className="col-sm-12 newReport column-ht" style={{ paddingTop: '0px', height: '100%' }}>
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car03.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: '12px' }}>
                              Owner Name
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.regdOwner.length > 15 ? caseinfo.regdOwner.slice(0, 14) : caseinfo.regdOwner}...</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Owner Serial No
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong> {caseinfo.ownerSerialNo}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Proposed Owner Name
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.name}</strong></p>
                            <hr />
                            {/* <br /> */}
                          </div>
                        </td>
                        <td width="25%">
                          <div className="col-sm-12 newReport column-ht" style={{ paddingTop: '0px', height: '100%' }}>
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car04.jpg"
                              width="auto"
                              height="10%"
                            />
                            {/* <br /> */}
                            <p style={{ fontSize: '12px' }}>
                              Report Requested by
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> {caseinfo.hypothecationBank}</p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Case Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.caseType}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Purpose Of Valuation
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.valuationPurpose}</strong></p>
                            <hr />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <div style={{ padding: 2 }} />
                  <table border={1} width="100%">
                    <tbody>
                      <tr
                        className="text-center"
                        style={{ border: "1px solid black", height: "30px" }}
                      >
                        <td
                          width="50%"
                          style={{ borderRight: "1px solid #686868" }}
                        >
                          Insurance Company
                          {/* <br /> */}
                          <p><strong>{caseinfo.insuranceCompany}</strong></p>
                        </td>
                        <td width="25%">
                          Insurance Status
                          {/* <br /> */}
                          <div>
                            {caseinfo.insuranceStatus === "Yes" ? (
                              <strong>Expired</strong>
                            ) : (
                              <strong>Running</strong>
                            )}
                          </div>
                        </td>
                        <td style={{ borderLeft: "1px solid #686868" }}>
                          Insurance Valid Till
                          {/* <br /> */}
                          <p> <strong>
                            {caseinfo.otherDetails.insuranceExpiry}
                          </strong></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div style={{ padding: 5 }} /> */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ height: "30px" }}>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          <p> &nbsp;&nbsp;Remarks&nbsp;:&nbsp;{caseinfo.yourRemark}</p>
                          {/* <br /> */}
                          <p> &nbsp;&nbsp;</p>
                          <a className="ps-2" target="_blank" href={caseinfo.videos} style={{ color: 'blue', textDecoration: 'underline' }}>
                            Preview Video Clip
                          </a>
                          &nbsp;
                          <a style={{ color: 'blue', textDecoration: 'underline' }} target="_blank"
                            href={caseinfo.imageUrl}
                          >
                            Preview Images
                          </a>
                        </td>
                        <td
                          width="35%"
                          rowSpan={2}
                          style={{ border: "1px solid black" }}
                        >
                          <div className="text-center">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src="/assets/stamp.jpeg"
                                width="50px"
                                height="50px"
                              />
                            </div>
                            <div>Authorized Signatory</div>
                            {/* <br /> */}
                          </div>
                        </td>
                      </tr>
                      <tr style={{ height: "20px" }}>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          &nbsp;&nbsp;Field Service By:&nbsp;
                          {
                            caseinfo.fieldServiceBy === 'agent' ? caseinfo.agent.name : ''
                          }
                          {
                            caseinfo.fieldServiceBy === 'executive' ? caseinfo.agent.name : ''
                          }
                          {
                            caseinfo.fieldServiceBy === 'executive' ? caseinfo.executive.name : ''
                          }
                          {
                            caseinfo.fieldServiceBy === 'customer' ? caseinfo.customer.name : ''
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                      height: "auto"
                    }}
                  >
                    {/* page footer */}
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      {/* <br /> */}
                      <p> Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,</p>
                      {/* <br /> */}
                      <p> Secunderabad 500003, Telengana</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* page footer ends */}
              {/* <div style={{ padding: 5 }} /> */}
            </div>

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
                height: "auto"
              }}
            >
              <div style={{ marginTop: 5 }}></div>
              <div
                style={{
                  padding: "2px 25px",
                  border: "1px solid #000",
                  width: "100%",
                  height: "auto"
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">

                    <h4>
                      <strong>
                        Valuation Report
                        <p>
                          {caseinfo.assetType}
                        </p>
                        <p>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</p>
                      </strong>
                    </h4>
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>

              {/*-  header */}
              <div className="row">
                <div className="col-sm-12 newReport">

                  <table
                    className="rcrowheight rtborder"
                    style={{ borderCollapse: "collapse" }}
                    width="100%"
                  >
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td>
                          <strong>REGISTRATION DETAILS</strong>
                        </td>
                        <td>
                          <strong>AS PER VAHAN</strong>
                        </td>
                        <td>
                          <strong>AS PER RC</strong>
                        </td>
                        <td>
                          <strong>AS PER ACTUAL</strong>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Reg. No</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.regdNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Chasis No&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.chassis}</td>
                        <td>{caseinfo.vehicleEdetails.chassis}</td>
                        <td>{caseinfo.chasisNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Engine No&nbsp;:&nbsp;</td>
                        <td> {caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.engNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Color</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleColor}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fuel Type&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.fueltype}</td>
                      </tr>

                      <tr style={{ height: "10px" }}>
                        <td width="35%">Owner Serial No</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.ownerSerialNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Reg Owner Name</td>
                        <td>{caseinfo.vehicleEdetails.owner}</td>
                        <td>{caseinfo.vehicleEdetails.owner}</td>
                        <td>{caseinfo.regdOwner}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Date Of Registration</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td>{caseinfo.regdDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">RTA Name</td>
                        <td> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Year Of Manufacture</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturingMonthYear}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturingMonthYear}</td>
                        <td>{caseinfo.regdDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fitness Expiry Date</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.otherDetails.fitnessExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Insurance Exp Date</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.otherDetails.insuranceExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Tax Valid Up To</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Up To</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Type</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Hypothecation</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td> {caseinfo.hypothecationBank}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Cubic Capacity</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.cubicCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Gross Vehicle Weight</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleWeight}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Seating Capacity</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td>{caseinfo.seatingCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Number Plate</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>{caseinfo.numberPlate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Status</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Blacklist Status</td>
                        <td>{caseinfo.vehicleEdetails.blacklistStatus}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Is Commercial</td>
                        {caseinfo.assetType === "Commercial" ? (
                          <td>Yes</td>
                        ) : (
                          <td>no</td>
                        )}
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Challan Details</td>
                        <td>NA</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: "5px" }}>
                    <strong>

                      OTHERS:
                    </strong>
                  </h4>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Document</td>
                        <td colSpan={2}> {caseinfo.documentVerification}</td>
                      </tr>
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Asset Type</td>
                        <td colSpan={2}>{caseinfo.assetType}</td>
                      </tr>
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Manufacturing Year</td>
                        <td colSpan={2}> {caseinfo.manufacturingDate}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: "5px" }}>
                    <strong>

                      DOCUMENT DETAILS:
                    </strong>
                  </h4>
                  <table className="rowheight" width="100%" height="auto">
                    <tbody>
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Fitness Expiry Date</td>
                        <td colSpan={2}>
                          {" "}
                          {caseinfo.otherDetails.fitnessExpiry}
                        </td>
                      </tr>
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Insurance</td>
                        <td colSpan={2}>{caseinfo.insuranceCompany}</td>
                      </tr>
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Road Tax Validity Upto</td>
                        <td colSpan={2}>
                          {" "}
                          {caseinfo.otherDetails.roadTaxValidity}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                      height: "auto"
                    }}
                  >
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      <p> Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,</p>
                      <p> Secunderabad 500003, Telengana</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- page 2 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
                height: "auto"
              }}
            >
              <div
                style={{
                  padding: "2px 25px",
                  border: "1px solid #000",
                  width: "100%",
                  height: "auto"
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">

                    <h4>
                      <strong>
                        Valuation Report
                        <br />
                        {caseinfo.assetType}
                        <br />
                        {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                      </strong>
                    </h4>
                    &nbsp;
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>
              {/*-  header */}
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  OTHER DETAILS:
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Fuel Type</td>
                    <td width="30%">{caseinfo.fueltype}</td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Gross Vehicle Weight</td>
                    <td width="30%">{caseinfo.vehicleWeight}</td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Odormeter Type</td>
                    <td width="30%">
                      {" "}
                      {caseinfo.additionalFeatures.odometer}
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Cubic Capacity</td>
                    <td width="30%">{caseinfo.cubicCapacity}</td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Vehicle Color</td>
                    <td width="30%">{caseinfo.vehicleColor}</td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Meter Reading In Km</td>
                    <td width="30%">{caseinfo.meterReading}</td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Number Plate</td>
                    <td width="30%">{caseinfo.numberPlate}</td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Seating Capacity</td>
                    <td width="30%">{caseinfo.seatingCapacity}</td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  ENGINE:
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Engine Condition</td>
                    <td width="30%">{caseinfo.otherDetails.engineCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.engineCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.engineCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.engineCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.engineCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.engineCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Cooling System</td>
                    <td width="30%">{caseinfo.twoWheeler.engine.coolingSystem}</td>
                    <td width="30%">

                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Cooling System Condition</td>
                    <td width="30%">{caseinfo.twoWheeler.engine.coolingSystemCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.engine.coolingSystemCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.coolingSystemCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.coolingSystemCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.coolingSystemCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.coolingSystemCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Fuel Tank</td>
                    <td width="30%">{caseinfo.twoWheeler.engine.fuelTank}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.engine.fuelTank === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.fuelTank === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.fuelTank === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.fuelTank === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.fuelTank === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Silencer</td>
                    <td width="30%">{caseinfo.twoWheeler.engine.silencer}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.engine.silencer === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.silencer === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.silencer === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.silencer === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.engine.silencer === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  TRANSMISSION:
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Transmission Type</td>
                    <td width="30%">{caseinfo.additionalFeatures.transmission}</td>
                    <td width="30%">
                      <span>&nbsp;</span>
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">                    Clutch Condition</td>
                    <td width="30%">{caseinfo.twoWheeler.transmission.clutchCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.transmission.clutchCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.clutchCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.clutchCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.clutchCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.clutchCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">                    GearBox Condition</td>
                    <td width="30%">{caseinfo.twoWheeler.transmission.gearboxCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.transmission.gearboxCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.gearboxCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.gearboxCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.gearboxCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.transmission.gearboxCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  SUSPENSION
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Front</td>
                    <td width="30%">{caseinfo.twoWheeler.suspension.front}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.suspension.front === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.front === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.front === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.front === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.front === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Rear</td>
                    <td width="30%">{caseinfo.twoWheeler.suspension.rear}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.suspension.rear === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.rear === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.rear === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.rear === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.suspension.rear === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  BRAKES
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Front Brake Type</td>
                    <td width="30%">{caseinfo.twoWheeler.brakes.frontBrakeType}</td>
                    <td width="30%">
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Front Brake Condition</td>
                    <td width="30%">{caseinfo.otherDetails.frontBrakeCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>

                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Rear Brake Type</td>
                    <td width="30%">{caseinfo.twoWheeler.brakes.rearBrakeType}</td>
                    <td width="30%">
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Rear Brake Condition</td>
                    <td width="30%">{caseinfo.otherDetails.rearBrakeCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearBrakeCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>

                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  TYRES & CONDITION
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Type</td>
                    <td width="30%">{caseinfo.twoWheeler.TyresNConditions.type}</td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Lh Front</td>
                    <td width="30%">{caseinfo.twoWheeler.TyresNConditions.lhFront}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhFront >= '0' && caseinfo.twoWheeler.TyresNConditions.lhFront <= 20 ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhFront >= '20.01' && caseinfo.twoWheeler.TyresNConditions.lhFront <= '40' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhFront >= '40.01' && caseinfo.twoWheeler.TyresNConditions.lhFront <= '60' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhFront >= '60.01' && caseinfo.twoWheeler.TyresNConditions.lhFront <= '80' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhFront >= '80.01' && caseinfo.twoWheeler.TyresNConditions.lhFront <= '100' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Lh Rear</td>
                    <td width="30%">{caseinfo.twoWheeler.TyresNConditions.lhRear}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhRear >= '0' && caseinfo.twoWheeler.TyresNConditions.lhRear <= 20 ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhRear >= '20.01' && caseinfo.twoWheeler.TyresNConditions.lhRear <= '40' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhRear >= '40.01' && caseinfo.twoWheeler.TyresNConditions.lhRear <= '60' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhRear >= '60.01' && caseinfo.twoWheeler.TyresNConditions.lhRear <= '80' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.TyresNConditions.lhRear >= '80.01' && caseinfo.twoWheeler.TyresNConditions.lhRear <= '100' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  {
                    caseinfo.otherDetails.spareTyre > '0' ?
                      <tr style={{ height: "5px" }}>
                        <td width="35%">Spare</td>
                        <td width="30%">{caseinfo.privateCar.TyresNConditions.spareTyre}</td>
                        <td width="30%">
                          {
                            caseinfo.twoWheeler.TyresNConditions.spareTyre >= '0' && caseinfo.twoWheeler.TyresNConditions.rhRear <= 20 ?
                              <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                          }
                          {
                            caseinfo.twoWheeler.TyresNConditions.spareTyre >= '20.01' && caseinfo.twoWheeler.TyresNConditions.rhRear <= '40' ?
                              <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                          }
                          {
                            caseinfo.twoWheeler.TyresNConditions.spareTyre >= '40.01' && caseinfo.twoWheeler.TyresNConditions.rhRear <= '60' ?
                              <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                          }
                          {
                            caseinfo.twoWheeler.TyresNConditions.spareTyre >= '60.01' && caseinfo.twoWheeler.TyresNConditions.rhRear <= '80' ?
                              <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                          }
                          {
                            caseinfo.twoWheeler.TyresNConditions.spareTyre >= '80.01' && caseinfo.twoWheeler.TyresNConditions.rhRear <= '100' ?
                              <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                          }
                        </td>
                      </tr> : <></>
                  }
                </tbody>
              </table>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Total Tyres Ex Spare</td>
                    <td width="30%">{caseinfo.otherDetails.totalTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Missing Tyres</td>
                    <td width="30%">{caseinfo.otherDetails.missingTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Spare Tyre</td>
                    <td width="30%">{caseinfo.otherDetails.spareTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                </tbody>
              </table>

              {/* <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                    }}
                  >
                 
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      <br />
                      J15-A, LANE NO-40, RAJAPURI,J15-UTTAM NAGAR,DELHI, 110059
                      <br />
                      Phone: 9866773092 | Email: pankaj623@gmail.com | Website:
                      https://www.adsum.co.in
                    </div>
                  </div>
                </div>
              
              </div>
              <div style={{ marginTop: 10 }}>&nbsp;</div> */}
            </div>
            {/* <!-- page 3 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 10px",
                width: "100%",
                height: "auto",
                border: "2px solid #000",
              }}
            >

              <div
                style={{
                  padding: "2px 25px",
                  border: "1px solid #000",
                  width: "100%",
                  height: "auto",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">

                    <h4>
                      <strong>
                        Valuation Report
                        <br />
                        {caseinfo.assetType}
                        <br />
                        {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                      </strong>
                    </h4>
                    &nbsp;
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>
              {/*-  header */}
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  WHEELS
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Wheel Type</td>
                    <td width="30%">{caseinfo.otherDetails.wheelsType}</td>
                    <td width="30%">---</td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  VEHICLE EXTERIOR
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Body Paint</td>
                    <td width="30%">{caseinfo.twoWheeler.vehicleExterior.bodyPaint}</td>
                    <td width="30%">
                      {caseinfo.twoWheeler.vehicleExterior.bodyPaint === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Paint Condition</td>
                    <td width="30%">{caseinfo.twoWheeler.vehicleExterior.paintCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.vehicleExterior.paintCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.paintCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.paintCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.paintCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.paintCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Body Condition</td>
                    <td width="30%">{caseinfo.twoWheeler.vehicleExterior.bodyCondition}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.vehicleExterior.bodyCondition === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.bodyCondition === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.bodyCondition === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.bodyCondition === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.vehicleExterior.bodyCondition === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Toolkit</td>
                    <td width="30%">{caseinfo.twoWheeler.vehicleExterior.toolKit}</td>
                    <td width="30%">
                      {caseinfo.twoWheeler.vehicleExterior.toolKit === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  ELECTRICALS:
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Battery Condition</td>
                    <td width="30%">{caseinfo.twoWheeler.electricals.battery}</td>
                    <td width="30%">
                      {
                        caseinfo.twoWheeler.electricals.battery === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.electricals.battery === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.electricals.battery === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.electricals.battery === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.twoWheeler.electricals.battery === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Ignition Type</td>
                    <td width="30%">{caseinfo.twoWheeler.electricals.ignitionType}</td>
                    <td width="30%">
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">HeadLamp</td>
                    <td width="30%">{caseinfo.otherDetails.headLamp}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.headLamp === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.headLamp === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.headLamp === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.headLamp === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.headLamp === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">TailLamp</td>
                    <td width="30%">{caseinfo.otherDetails.tailLamp}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.tailLamp === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.tailLamp === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.tailLamp === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.tailLamp === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.tailLamp === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Front Indicators</td>
                    <td width="30%" >{caseinfo.otherDetails.frontIndicators}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.frontIndicators === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.frontIndicators === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.frontIndicators === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.frontIndicators === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.frontIndicators === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Rear Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.rearIndicators}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.rearIndicators === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearIndicators === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearIndicators === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearIndicators === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.rearIndicators === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">speedometerPanel</td>
                    <td width="30%">{caseinfo.twoWheeler.electricals.speedometerPanel}</td>
                    <td width="30%">
                      {caseinfo.twoWheeler.electricals.speedometerPanel === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Accessories</td>
                    <td width="30%">{caseinfo.twoWheeler.electricals.accessories}</td>
                    <td width="30%">
                      {caseinfo.twoWheeler.electricals.accessories === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>
                  ADDITIONAL DETAILS:
                </strong>
              </h4>
              <table className="rowheight" width="100%" height="auto">
                <tbody>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Whether Accidental</td>
                    <td width="30%">{caseinfo.otherDetails.accidental}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.accidental === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Level Of Maintenance</td>
                    <td width="30%">{caseinfo.otherDetails.levelOfMaintenance}</td>
                    <td width="30%">
                      {
                        caseinfo.otherDetails.levelOfMaintenance === 'Poor' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.levelOfMaintenance === 'Average' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.levelOfMaintenance === 'Satisfactory' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.levelOfMaintenance === 'Good' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" /> : <></>
                      }
                      {
                        caseinfo.otherDetails.levelOfMaintenance === 'Excellent' ?
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" /> : <></>
                      }
                    </td>
                  </tr>
                  <tr style={{ height: "5px" }}>
                    <td width="35%">Other Repairs If Any</td>
                    <td width="30%">{caseinfo.otherDetails.otherRepair}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.otherRepair === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* <div style={{ marginTop: 30 }}>&nbsp;</div> */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                      height: "auto"
                    }}
                  >
                    {/* page footer */}
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      <br />
                      Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,
                      <br />
                      Secunderabad 500003, Telengana
                    </div>
                  </div>
                </div>
                {/* page footer ends */}
              </div>
              <div style={{ marginTop: 10 }}>&nbsp;</div>
            </div>
            {/* <!-- page 4 ends --> */}
            <div className="page-break" />
            <div style={{ marginTop: 10 }}>&nbsp;</div>
            <div
              style={{
                padding: "2px 25px",
                border: "1px solid #000",
                width: "100%",
                height: "auto"
              }}
            >
              <div className="row">
                <div className="col-sm-3 p-2">
                  <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                </div>
                <div className="col-sm-6 text-center">
                  <br />
                  <h4>
                    <strong>
                      Valuation Report
                      <br />
                      {caseinfo.assetType}
                      <br />
                      {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                    </strong>
                  </h4>
                  &nbsp;
                </div>
                <div className="col-sm-3 text-right">
                  <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                </div>
              </div>
            </div>
            {/*-  header */}

            {/*- content border */}
            <h4>
              <p>
                IMAGES:
              </p>
            </h4>
            <div className="row">
              <div className="col-sm-12 newReport">
                <table className="rowheight" width="100%" height="auto">
                  <tbody>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }} >
                        <a target="_blank" href={caseinfo.images.selfieWithVehicle}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.selfieWithVehicle}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.frontImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.frontImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.frontUnderCar}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.frontUnderCar}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rearImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rearImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rearUnderPart}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rearUnderPart}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.right45}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.right45}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 12 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                        height: "auto"
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                {/* <div className="page-break" /> */}
                {/*div class="content" style="margin:30px 0 0 0; padding:0 10px; width:100%;border:1px solid #00f;" */}
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <div
                  style={{
                    padding: "2px 25px",
                    border: "1px solid #000",
                    width: "100%",
                    height: "auto"
                  }}
                >
                  <div className="row">
                    <div className="col-sm-3 p-2">
                      <img
                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                    </div>
                    <div className="col-sm-6 text-center">
                      <br />
                      <h4>
                        <strong>
                          Valuation Report
                          <br />
                          {caseinfo.assetType}
                          <br />
                          {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                        </strong>
                      </h4>
                      {/* Ex. Showroom Price&nbsp;:&nbsp;3300000 */}
                    </div>
                    <div className="col-sm-3 text-right">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                    </div>
                  </div>
                </div>
                {/*-  header */}
                <table className="rowheight" width="100%" height="auto">
                  <tbody>
                    <tr />
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rightImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rightImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.left45}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.left45}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.leftImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.leftImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.chasisImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.chasisImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.openBonnet}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.openBonnet}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.openDickey}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.openDickey}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 12 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                        height: "auto"
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                <div className="page-break" />
                {/*div class="content" style="margin:30px 0 0 0; padding:0 10px; width:100%;border:1px solid #00f;" */}
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <div
                  style={{
                    padding: "2px 25px",
                    border: "1px solid #000",
                    width: "100%",
                    height: "auto"
                  }}
                >
                  <div className="row">
                    <div className="col-sm-3 p-2">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                    </div>
                    <div className="col-sm-6 text-center">
                      <br />
                      <h4>
                        <strong>
                          Valuation Report
                          <br />
                          {caseinfo.assetType}
                          <br />
                          {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                        </strong>
                      </h4>
                      {/* Ex. Showroom Price&nbsp;:&nbsp;3300000 */}
                    </div>
                    <div className="col-sm-3 text-right">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                    </div>
                  </div>
                </div>
                {/*-  header */}
                <table className="rowheight" width="100%" height="auto">
                  <tbody>
                    <tr />
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.tyreImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.tyreImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.glassInside}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.glassInside}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.glassOutside}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.glassOutside}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.odometerImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.odometerImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rpmImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rpmImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.tyreImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.tyreImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 12 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                        height: "auto"
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                <div className="page-break" />
                {/*div class="content" style="margin:30px 0 0 0; padding:0 10px; width:100%;border:1px solid #00f;" */}
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <div
                  style={{
                    padding: "2px 25px",
                    border: "1px solid #000",
                    width: "100%",
                    height: "auto"
                  }}
                >
                  <div className="row">
                    <div className="col-sm-3 p-2">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                    </div>
                    <div className="col-sm-6 text-center">
                      <br />
                      <h4>
                        <strong>
                          Valuation Report
                          <br />
                          {caseinfo.assetType}
                          <br />
                          {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                        </strong>
                      </h4>
                      {/* Ex. Showroom Price&nbsp;:&nbsp;3300000 */}
                    </div>
                    <div className="col-sm-3 text-right">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                    </div>
                  </div>
                </div>
                {/*-  header */}
                <table className="rowheight" width="100%" height="auto">
                  <tbody>
                    {/* <tr /> */}
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.anyDamage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.anyDamage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rcBack}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.signNdoc.rcBack}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr style={{ height: "5px" }}>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rcFront}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.signNdoc.rcFront}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.sign}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.signNdoc.sign}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{ padding: "15px 10px", border: "1px solid #686868" }}
                    >
                      Disclaimer:
                      {/* <br /> */}
                      <p> o This report is issued without prejudice</p>
                      {/* <br /> */}
                      <p>o The valuation has been done based on the superficial
                        examination of vehicle condition and the doeuments provided at
                        the time of inspection.</p>
                      {/* <br /> */}
                      <p> o This report is valid for the date of inspection and time
                        only</p>
                      {/* <br /> */}
                      <p> o This valuation has been performed to the best of our ability
                        and our responsibility is limited to proven negligence.</p>
                      {/* <br /> */}
                      <div className="text-right">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            marginRight: '20px'
                          }}
                        >
                          <img
                            src="/assets/stamp.jpeg"
                            width="50px"
                            height="50px"
                          />
                        </div>
                        {/* <br /> */}
                        Authorized Signatory
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                        height: "auto"
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>


              </div>
            </div>
            <br />
            {/* /div> <!-- A4 size */}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default TwoWheelerReport;
